
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/showPayModal",
      function () {
        return require("private-next-pages/showPayModal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/showPayModal"])
      });
    }
  